import { jsx, Fragment } from 'react/jsx-runtime';
import { useContext, useEffect, useMemo } from 'react';
import { withStore } from 'justorm/react';
import STORE from './store.js';
import Context from './context.js';
import { parsePath, replaceParamsInPath } from './Router.helpers.js';
export { Route } from './Route.js';
export { Redirect } from './Redirect.js';
export { Link } from './Link/Link.js';

const Router = withStore({
    router: ['path'],
})((props) => {
    const { children, single, basePath = '', store: { router }, } = props;
    const ctx = useContext(Context);
    const fullPath = ctx.basePath + basePath;
    useEffect(() => {
        const onPopState = () => {
            STORE.go(window.location.pathname, { replace: true });
        };
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);
    const matchedRoutes = useMemo(() => {
        const childs = [];
        let isRouteMatched = false;
        for (const child of React.Children.toArray(children)) {
            if (!React.isValidElement(child)) {
                childs.push(child);
                continue;
            }
            const { path, exact, component: Component, ...rest } = child.props;
            if (!path) {
                childs.push(child);
                continue;
            }
            if (single && isRouteMatched) {
                continue;
            }
            const tailPath = fullPath && path === '/' ? '' : path;
            const routePath = fullPath + tailPath;
            const params = parsePath(router.path, routePath, exact);
            if (params) {
                const routeBasePath = fullPath + replaceParamsInPath(path, params);
                const matchedRoute = (jsx(Context.Provider, { value: { basePath: routeBasePath }, children: jsx(Component, { ...rest, pathParams: params }) }, path));
                isRouteMatched = true;
                childs.push(matchedRoute);
            }
        }
        return childs;
    }, [children, router.path, fullPath, single]);
    return jsx(Fragment, { children: matchedRoutes });
});
Router.displayName = 'Router';
const RouterStore = STORE;
const RouterContext = Context;

export { Router, RouterContext, RouterStore };
